<div class="otp-input-wrapper">
  <div class="otp-digit-container"></div>
  <div class="otp-digit-container"></div>
  <div class="otp-digit-container"></div>
  <div class="otp-digit-container"></div>
  <div class="otp-digit-container"></div>
  <input #otpInput type="text" pattern="[0-9]*" autocomplete="nope" inputmode="numeric" [(ngModel)]="validationCode"
    (paste)="onPaste($event)" (keydown)="onKeydown($event)" (keyup)="onKeyup($event)" (onFocus)="onFocus($event)" (input)="onInput($event)">
  <div class="otp-digit-container"></div>
</div>